import get from 'lodash-es/get'
import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import { shortenNumber } from '../../../../common/utils/formatString'
import StarRating from '../../../components/starRating'

import * as styles from './lockupRating.module.css'

interface IProps {
  item: IItem
}

const LockupRating = ({ item }: IProps) => {
  const { rating } = item
  const ratingCount = get(item, 'rating.count')

  if (ratingCount < 3) {
    return null
  }

  return (
    <div className={styles.root}>
      <StarRating rating={rating.rating} className={styles.starRating} />
      <span className={styles.starRatingCount}>
        ({shortenNumber(ratingCount)})
      </span>
    </div>
  )
}

export default LockupRating
